<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<h2 mat-dialog-title>Add User</h2>
<mat-dialog-content>
  <div>
    <mat-form-field class="mr-16" appearance="outline">
      <mat-label>First Name</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="user.firstName"
        matInput
        placeholder="Enter first name"
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Last Name</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="user.lastName"
        matInput
        placeholder="Enter last name"
      />
    </mat-form-field>
  </div>

  <div>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Birth Date</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="birthDate"
        matInput
        [matDatepicker]="birthPicker"
        (input)="onRawDateInput($event, 'birthDate')"
        placeholder="TT.MM.JJJJ"
          maxlength="10"

      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="birthPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #birthPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field class="mr-16" appearance="outline">
      <mat-label>E-Mail</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="user.mail"
        matInput
        placeholder="Enter E-Mail"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Phone</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="user.phone"
        type="tel"
        matInput
        placeholder="0123456789"
        pattern="^[0-9]*$"
      />
    </mat-form-field>
  </div>

  <div>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Street + House No.</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="user.street"
        matInput
        placeholder="Enter street + No."
      />
      <!-- <mat-hint>Please enter a name</mat-hint> -->
    </mat-form-field>
  </div>

  <div>
    <mat-form-field class="mr-16" appearance="outline">
      <mat-label>Zip code</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="user.zipCode"
        matInput
        placeholder="Enter zip code"
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>City</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="user.city"
        matInput
        placeholder="Enter city"
      />
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Notice</mat-label>
      <textarea
        [disabled]="loading"
        [(ngModel)]="user.notice"
        matInput
        placeholder="Enter notice"
        rows="4"
      ></textarea>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Date</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="user.date"
        matInput
        [matDatepicker]="userPicker"
        (input)="onRawDateInput($event, 'date')"
        placeholder="Enter Date"
          maxlength="10"

      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="userPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #userPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Time</mat-label>
      <input
        [disabled]="loading"
        [(ngModel)]="timePart"
        matInput
        type="time"
        placeholder="HH:mm"
      />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-button (click)="saveUser()">Save</button>
</mat-dialog-actions>
